import React, { useCallback, useEffect } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";

const Icon = () => (
    <div className="flex w-full items-center justify-center py-10">
        <FontAwesomeIcon icon={faInfoCircle} size="6x" />
    </div>
);

const USPBlockRenderer = ({
    state: { usps = [], selectedCardIndex = null },
    isEditMode,
    onChange,
    focused,
}) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        align: "start",
        breakpoints: {
            992: { dragFree: true },
        },
    });

    const onScroll = useCallback(() => {}, []);

    useEffect(() => {
        if (!emblaApi) return;

        onScroll(emblaApi);

        emblaApi
            .on("reInit", onScroll)
            .on("scroll", onScroll)
            .on("slideFocus", onScroll);
    }, [emblaApi, onScroll]);

    if (usps.length === 0) {
        return <Icon />;
    }

    return (
        <div ref={emblaRef} className="overflow-hidden">
            <div className="flex gap-[15px] md:gap-[30px]">
                {usps.map((usp, idx) => (
                    <div
                        key={`usp_${idx}`}
                        data-testid={`usps__item-${idx}`}
                        style={{
                            boxShadow:
                                selectedCardIndex === idx &&
                                focused &&
                                "inset 0 0 0 3px red",
                        }}
                        className="flex flex-[0_0_240px] flex-col gap-y-[30px] rounded-[10px] bg-brand-light-grey p-[15px] md:flex-1"
                        onClick={(e) => {
                            if (isEditMode) {
                                e.preventDefault();
                                onChange({
                                    selectedCardIndex: idx,
                                });
                            }
                        }}
                    >
                        <div className="flex flex-row items-center gap-x-[10px]">
                            {usp.icon && (
                                <img
                                    src={usp.icon}
                                    alt=""
                                    className="h-[32px] w-[32px] flex-shrink-0 object-contain"
                                />
                            )}

                            {usp.content && (
                                <div
                                    className="!mb-0 flex-1"
                                    dangerouslySetInnerHTML={{
                                        __html: usp.content,
                                    }}
                                />
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default USPBlockRenderer;
